import React, { useState } from "react";
import { Pressable, Text, Image, StyleSheet } from "react-native";
import {
  PALOMA_NAVY,
  PALOMA_NAVY_PRESSED,
  PALOMA_ACCENT_BLUE,
  PALOMA_TEXT_ON_NAVY,
} from "../../constants/palomaPaloozaBrand";

const PP_LOGO = require("../../assets/paloma-palooza-logo.png");

/** Map top bar — Paloma Palooza promo (opens promo sheet). */
export default function MapHeavenHillsButton({ onPress }) {
  const [pressed, setPressed] = useState(false);

  return (
    <Pressable
      onPress={onPress}
      onPressIn={() => setPressed(true)}
      onPressOut={() => setPressed(false)}
      accessibilityRole="button"
      accessibilityLabel="Paloma Palooza"
      style={[styles.button, pressed && styles.buttonPressed]}
    >
      <Image source={PP_LOGO} style={styles.logo} resizeMode="contain" accessibilityIgnoresInvertColors />
      <Text style={styles.label}>Paloma Palooza</Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    height: 36,
    flexShrink: 0,
    paddingHorizontal: 6,
    backgroundColor: PALOMA_NAVY,
    borderWidth: 2,
    borderColor: PALOMA_ACCENT_BLUE,
    borderRadius: 999,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3,
    elevation: 4,
  },
  buttonPressed: {
    backgroundColor: PALOMA_NAVY_PRESSED,
    borderColor: PALOMA_ACCENT_BLUE,
  },
  logo: {
    width: 16,
    height: 16,
    borderRadius: 3,
  },
  label: {
    marginLeft: 4,
    fontSize: 12,
    lineHeight: 16,
    fontWeight: "700",
    color: PALOMA_TEXT_ON_NAVY,
    fontFamily: "AbhayaLibre_700Bold, serif",
  },
});
